import constate from "constate";
import { useState } from "react";

interface UseAllRolesFilterParams {
  initialValue?: boolean;
}

/**
 * Local UI state for the "All Roles" filter option in shift blocks.
 *
 * This is a purely presentational concern - when enabled, shift blocks
 * are shown for all qualifications instead of filtering by a single one.
 *
 * This state is intentionally NOT persisted to the backend worker preferences,
 * as "All Roles" is not a valid qualification value.
 */
function useAllRolesFilter({ initialValue = false }: UseAllRolesFilterParams = {}) {
  const [isAllRolesSelected, setIsAllRolesSelected] = useState(initialValue);

  return {
    isAllRolesSelected,
    setIsAllRolesSelected,
  };
}

export const [AllRolesFilterProvider, useAllRolesFilterContext] = constate(useAllRolesFilter);
